import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { reaction } from "mobx";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import { Clip } from "../Clip/Clip";
import { CompositionStateStore } from "../../../../store/CompositionStateStore";

import "./TextClip.styles.scss";

interface TextClipProps {
    clipId: string;
    layerId: string;
}

export const TextClip: React.FC<TextClipProps> = observer(({ clipId, layerId }) => {
    const [title, setTitle] = useState<string | undefined>(CompositionStateStore.getClipTitle(clipId));

    useEffect(() => {
        const disposer = reaction(
            () => ({
                title: CompositionStateStore.getClipTitle(clipId),
            }),
            ({ title }) => setTitle(title),
            { fireImmediately: true }
        );
        return () => disposer();
    }, [clipId]);

    return (
        <Clip
            clipId={clipId}
            layerId={layerId}
            filename={title ?? "Text"}
            backgroundColor={"204, 204, 204"}
            showAudioTransitions={false}
            showVisualTransitions={false}
        >
            <TextFieldsIcon sx={{ fontSize: 14, color: "white" }} />
        </Clip>
    );
});

export default TextClip;
